export default class BDiaryDaySidebar
{
	constructor(el)
	{
		this.el = el;
	}

	setHtml(template)
	{
		this.el.innerHTML = template;
	}
}
